export default {
  listaTipoAtendimentos: [],
  tipoAtendimento: {
    id: null,
    descricao: '',
    ativo: true,
  },
}
